import { nanoid } from 'nanoid';

import { State } from '../../../types/chat';

export const initialState: State = {
  apiKey: undefined,
  userId: nanoid(10),
  userName: undefined,
  userToken: undefined,
  channelId: `the-small-council_${nanoid(10)}`,
  channel: undefined,
  client: undefined,
  loading: true,
  feedback: undefined,
  message: undefined,
  reaction: undefined,
  response: undefined,
  listening: undefined,
  event: undefined,
};
